import { render } from "./DragCard2.vue?vue&type=template&id=57d0595c&scoped=true&ts=true"
import script from "./DragCard2.vue?vue&type=script&lang=ts"
export * from "./DragCard2.vue?vue&type=script&lang=ts"

import "./DragCard2.vue?vue&type=style&index=0&id=57d0595c&lang=scss&scoped=true"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57d0595c"]])

export default __exports__